export default __webpack_public_path__ + "static/media/03.c9911bb9.jpg";